define('modules/profiles/subviews/views/profile.monitoring.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/following.view",
    "text!modules/profiles/subviews/templates/profile.monitoring.template.html"
], function (Prospector,
             $, _, Backbone, Marionette,
             FollowingView,
             Template) {
    var ProfileMonitoringView = FollowingView.extend({
        template: _.template(Template),
        className: 'monitorBtn horizontalIcon fRight',
        followingState:{
            text: 'Monitoring',
            icon: 'fa-eye'
        },
        followState:{
            text: 'Monitor',
            icon: 'fa-eye-slash'
        },
        mainAttr: 'roleMonitoring',
        alertType: 2,
        limitAttr: 'roleMonitoringLimit',
        totalAttr: 'totalRoleMonitoring',
        initialize: function (options) {
            this.parent = options.parent;
            FollowingView.prototype.initialize.call(this, options);
        }
    });
    return ProfileMonitoringView;
});


